import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoggedIn: false,
  backendVersion: '',
  webToken: '',
  authId: 0,
  userId: '',
  firstName: '',
  lastName: '',
  subscriberId: 0,
  // accountType (GateSubscriber-level, delivered by the login payload): 'agency' =
  // manages multiple GateCustomers (default); 'direct' = the subscriber IS its own
  // customer, so the Setup UI collapses/hides the Customer layer. Provisioned only by
  // the Dividia super-user; the frontend just reads it here to gate nav + hierarchy.
  accountType: 'agency',
  customerId: 0,
  customerName: '',
  siteId: 0,
  gateId: 0,
  gateAssignmentId: 0,
  // [86bbumedw] email/user accounts: the signed-in user's email, and a force-change flag.
  // changePassword === 'true' (set by the login payload when the backend fChangePassword is
  // on, i.e. right after an admin temp-password create/reset) makes App.js show the
  // set-a-new-password screen before the console; cleared once the new password is saved.
  sEmail: '',
  changePassword: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
    login: (state, action) => {
      state.isLoggedIn = true
      state.backendVersion = action.payload.backendVersion ? action.payload.backendVersion : ''
      state.authId = action.payload.gateAclId
      state.userId = action.payload.id
      state.firstName = action.payload.sFirst
      state.lastName = action.payload.sLast
      state.subscriberId = action.payload.subscriberId
      state.accountType = action.payload.accountType || 'agency'
      state.customerId = action.payload.customerId
      state.customerName = action.payload.customerName ? action.payload.customerName  : 'Customer N/A'
      state.siteId = action.payload.siteId
      state.gateId = action.payload.gateId
      state.gateAssignmentId = action.payload.gateAssignmentId
      state.sEmail = action.payload.sEmail || ''
      state.changePassword = action.payload.changePassword || null
    },
    logout: (state, action) => {
      return { ...initialState }
    },
  },
})

export const { setAuthState, login, logout } = authSlice.actions
export default authSlice.reducer
